
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_1mabk_7hcep_3",
  "radio": "awsui_radio_1mabk_7hcep_14",
  "radio--has-description": "awsui_radio--has-description_1mabk_7hcep_22",
  "radio-control": "awsui_radio-control_1mabk_7hcep_26",
  "input": "awsui_input_1mabk_7hcep_34",
  "styled-circle-border": "awsui_styled-circle-border_1mabk_7hcep_56",
  "styled-circle-disabled": "awsui_styled-circle-disabled_1mabk_7hcep_60",
  "styled-circle-fill": "awsui_styled-circle-fill_1mabk_7hcep_65",
  "styled-circle-checked": "awsui_styled-circle-checked_1mabk_7hcep_71"
};
  